import { useGiggedApiSWR } from "./common/giggedApiSWR";
import { GigOrderByFieldKeys, GigSummary } from "../models/app/gig";
import { ApiGigSummary } from "../models/api/gig";
import { mapFromApiGigSummary } from "../models/mappers/gig";
import { useStateParams } from "../hooks/useStateParams";
import { GigApiPaginatedData } from "./common/apiResponse";
import { ITEMS_PER_PAGE } from "./common/pagination";
import { SortOrder } from "./common/sortOrder";

export type UseTalentMyOngoingGigsReturn = {
    gigs: GigSummary[]
    isLoading: boolean
    mutate: () => void
    pageIndex: number
    pageSize: number
    totalCount: number
    totalPages: number
    hasPreviousPage: boolean
    hasNextPage: boolean
    setPageIndex: (pageIndex: number) => void
    setPageSize: (pageSize: number) => void
}

type UseTalentOngoingGigsParams = {
    gigStatusIds: number[]
    inviteStatusIds?: number[]
    orderBy?: GigOrderByFieldKeys
    sortOrder?: SortOrder
}

export const useTalentOngoingGigs = ({
    gigStatusIds,
    inviteStatusIds,
    orderBy = "Title",
    sortOrder = "asc"
}: UseTalentOngoingGigsParams): UseTalentMyOngoingGigsReturn => {
    const [pageIndex, setPageIndex] = useStateParams<number>(0, "pageIndex", "number");
    const [pageSize, setPageSize] = useStateParams<number>(ITEMS_PER_PAGE, "pageSize", "number");
    
    const statusIdsParam = gigStatusIds.join(",");
    const inviteStatusIdsParam = inviteStatusIds?.length ? `&inviteStatusIds=${inviteStatusIds.join(",")}` : "";
    
    const url = "api/me/gigs/queries/hired?" +
        `pageIndex=${pageIndex}` +
        `&pageSize=${pageSize}` +
        `&gigStatusIds=${statusIdsParam}` +
        inviteStatusIdsParam +
        `&orderBy=${orderBy}` +
        `&sortOrder=${sortOrder}`;

    const { data, isLoading, mutate } =
        useGiggedApiSWR<GigApiPaginatedData<ApiGigSummary>>(url);

    const gigs = data?.items ? data.items.map(mapFromApiGigSummary) : [];

    return {
        isLoading,
        gigs,
        mutate,
        pageIndex: data?.pageIndex ?? 0,
        pageSize: data?.pageSize ?? pageSize,
        totalCount: data?.totalCount ?? 0,
        totalPages: data?.totalPages ?? 0,
        hasPreviousPage: data?.hasPreviousPage ?? false,
        hasNextPage: data?.hasNextPage ?? false,
        setPageIndex,
        setPageSize,
    };
};